import { render, staticRenderFns } from "./ComponentCreateDialog.vue?vue&type=template&id=74a15fb6&scoped=true&"
import script from "./ComponentCreateDialog.vue?vue&type=script&lang=ts&"
export * from "./ComponentCreateDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ComponentCreateDialog.vue?vue&type=style&index=0&id=74a15fb6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a15fb6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCard,VCardText,VContainer,VDialog,VIcon,VSpacer,VToolbar})
